import classNames from 'clsx'
import { Fragment, type ReactElement, type VFC } from 'react'

import { DEFAULT_NUMBER_OF_VISIBLE_ITEM } from 'views/consts'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

export const SliderListItems: VFC<{
  items: ReactElement[]
  colSize: number
  noSlider: boolean
  showBuyButton?: boolean
}> = ({ items, colSize, noSlider, showBuyButton = false }) => {
  return (
    <Fragment>
      {items.map(item => (
        <li
          className={classNames(
            'o-SliderHorizontal__item',
            'l-col--12-of-12',
            `l-col--${Math.ceil(colSize * 2)}-of-12@tiny`,
            `l-col--${Math.ceil(colSize)}-of-12@medium`,
            {
              'o-SliderHorizontal__item--no-slider l-flex l-flex--stretch-children':
                noSlider,
              'o-SliderHorizontal__item--only-item': items.length === 1,
              'o-SliderHorizontal__item--with-buy-button': showBuyButton,
            }
          )}
          key={item.key}
          data-clientside-hook="slider__item"
        >
          {item}
        </li>
      ))}
    </Fragment>
  )
}

const SliderItemsList: VFC<SliderItemsListProps> = ({
  stretch,
  centered,
  noSlider,
  noAutoFullWidth,
  items,
  colSize,
  showBuyButton,
}) => {
  return (
    <ul
      className={classNames(
        'o-SliderHorizontal__list a-list-reset u-position--relative',
        {
          'o-SliderHorizontal__list--stretch': stretch,
          'u-margin--auto': centered && !noSlider,
          'o-SliderHorizontal__list--no-slider': noSlider,
          'a-list-inline': !noSlider,
          'a-full-width':
            !noAutoFullWidth && items.length < DEFAULT_NUMBER_OF_VISIBLE_ITEM,
        }
      )}
      data-clientside-hook="slider__items"
    >
      <SliderListItems
        items={items}
        colSize={colSize}
        noSlider={noSlider}
        showBuyButton={showBuyButton}
      />
    </ul>
  )
}

type SliderItemsListProps = {
  stretch: boolean
  centered: boolean
  noSlider: boolean
  noAutoFullWidth: boolean
  items: ReactElement[]
  colSize: number
  showBuyButton: boolean
}
export default withShopAndRuntimeConfig(SliderItemsList)
